<p-toast key="toast" [breakpoints]="{ '920px': { width: '100%', right: '0', left: '0' } }" [baseZIndex]="99999"></p-toast>

<!-- Sticky PUP Credit export toast: loading -> link / error. Stays until dismissed. -->
<p-toast key="pupCredit" styleClass="pup-credit-toast" position="top-right" [baseZIndex]="100000"
  [breakpoints]="{ '920px': { width: '100%', right: '0', left: '0' } }">
  <ng-template let-message pTemplate="message">
    @if (message.data?.state === 'loading') {
      <div class="flex flex-column gap-2" style="flex: 1 1 auto;">
        <span class="pup-toast__title">{{ message.data.title }}</span>
        <div class="flex align-items-center gap-3">
          <p-progressBar class="pup-toast__bar" mode="determinate"
            [value]="pupCreditExport.progress()" [showValue]="false"></p-progressBar>
          <span class="pup-toast__pct">{{ pupCreditExport.progress() }}%</span>
        </div>
        <span class="pup-toast__hint">Keep working, the link appears here.</span>
      </div>
    } @else if (message.data?.state === 'done') {
      <div class="flex align-items-start gap-3" style="flex: 1 1 auto;">
        <i class="pi pi-check-circle text-xl mt-1 text-green-400"></i>
        <div class="flex flex-column gap-2">
          <span class="pup-toast__title">{{ message.data.title }}</span>
          <a [href]="message.data.url" target="_blank" rel="noopener"
            class="inline-flex align-items-center gap-2 font-medium text-primary no-underline">
            <i class="pi pi-external-link"></i>Open sheet
          </a>
        </div>
      </div>
    } @else {
      <div class="flex align-items-start gap-3" style="flex: 1 1 auto;">
        <i class="pi pi-exclamation-circle text-xl mt-1 text-red-400"></i>
        <div class="flex flex-column gap-1">
          <span class="pup-toast__title">{{ message.data?.title }}</span>
          <span class="pup-toast__hint">{{ message.data?.message }}</span>
        </div>
      </div>
    }
  </ng-template>
</p-toast>
<div class="layout-wrapper" [ngClass]="containerClass">
    <app-topbar></app-topbar>
    <div class="layout-sidebar">
        <app-sidebar></app-sidebar>
    </div>
    <div class="layout-main-container">
        <div class="layout-main">
            <router-outlet></router-outlet>
        </div>
        <app-footer></app-footer>
    </div>
    <div class="layout-mask"></div>
</div>
